import isBlank from './Blank';

const isPresent = value => ! isBlank(value);

export default isPresent;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/Present.tsx